export default "<app-main-template [navItems]='navSections'></app-main-template>\n"